import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { ProductKey } from '@/modules/estate/enums/ProductKey';
import { EstateConsent } from '@/modules/estate/models/EstateConsent';

export class CheckoutSessionCart extends BaseModel {
  productKeys: ProductKey[];
  successUrl?: string;
  consentToPlanningPurchaseTerms: EstateConsent | undefined;

  constructor(model: Partial<CheckoutSessionCart> = {}) {
    super(model);

    this.productKeys = model.productKeys ?? [];
    this.successUrl = model.successUrl;
    this.consentToPlanningPurchaseTerms =
      EstateConsent.mapModelOrNull(model.consentToPlanningPurchaseTerms) ?? undefined;
  }

  removeProductKey(keyToRemove: ProductKey): void {
    this.productKeys = this.productKeys.filter((key: ProductKey) => key !== keyToRemove);
  }
}
